import { he } from "date-fns/locale";
import { IconProps } from "./types";

export default function IcoAdd({
	color = "#000000",
	width = "12",
	height = "12"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 11 13"
			fill="none"
		>
			<g clipPath="url(#clip0_647_1455)">
				<path
					d="M6.21875 2.375C6.21875 1.96016 5.88359 1.625 5.46875 1.625C5.05391 1.625 4.71875 1.96016 4.71875 2.375V5.75H1.34375C0.928906 5.75 0.59375 6.08516 0.59375 6.5C0.59375 6.91484 0.928906 7.25 1.34375 7.25H4.71875V10.625C4.71875 11.0398 5.05391 11.375 5.46875 11.375C5.88359 11.375 6.21875 11.0398 6.21875 10.625V7.25H9.59375C10.0086 7.25 10.3438 6.91484 10.3438 6.5C10.3438 6.08516 10.0086 5.75 9.59375 5.75H6.21875V2.375Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_647_1455">
					<path d="M0.21875 0.5H10.7188V12.5H0.21875V0.5Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
